const state = { 
    show: false
};

const mutations = {
    toggleShow: state => state.show = !state.show
};

const actions = { 
};

const getters = { 
    show: state => state.show
};

export default {
    namespaced: true,
    state, 
    mutations,
    actions,
    getters
};